import classes from './DownArrow.module.css';
import AnchorLink from 'react-anchor-link-smooth-scroll';

function DownArrow(){
    return <div className={classes.container}>
                <AnchorLink offset='10%' href='#form'><img src='./images/arrow.png' alt='arrow'/></AnchorLink>
            </div>
}
export default DownArrow;